/**
 * Activate a row on Enter or Space. Lets modifier+Enter/Space (e.g. cmd+Enter)
 * pass through to global hotkeys, and ignores events bubbled from focusable
 * descendants (e.g. a checkbox inside the row's expandable panel) so their
 * Enter doesn't also collapse the row.
 */
export const activateOnEnterOrSpace = (
  e: React.KeyboardEvent,
  handler: (e: React.MouseEvent) => void,
) => {
  if (e.metaKey || e.ctrlKey || e.altKey) return
  if (e.key !== 'Enter' && e.key !== ' ') return
  if (e.currentTarget !== e.target) return
  e.preventDefault()
  handler(e as unknown as React.MouseEvent)
}
